export default function ReceiveIcon() {
  return (
    <svg width='14' height='20' viewBox='0 0 14 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <rect x='9.33398' y='9.84058' width='4.66676' height='5.07956' fill='currentColor' />
      <rect y='9.84058' width='4.66676' height='5.07956' fill='currentColor' />
      <rect x='4.95898' y='-0.000244141' width='4.66676' height='5.07956' fill='currentColor' />
      <rect x='4.66797' y='14.9207' width='4.66676' height='5.07956' fill='currentColor' />
    </svg>
  )
}
